import type {SafetyEventViewType} from 'src/app/safety-events/SafetyEventForm';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {BaseRouteService} from './BaseRouteService';
import type {ViewModeType} from './IRouteService';

export class SafetyEventRouteService extends BaseRouteService {
  constructor(
    enableGoHome: boolean,
    mode: ViewModeType,
    parameters: {[key: string]: any}
  ) {
    super(enableGoHome, mode, parameters);
  }

  isGoHomeEnabled(): boolean {
    return this.enableGoHome;
  }

  getCreateRoute(): string {
    return PathUtility.SafetyEventCreate();
  }

  getEditRoute(id: string | number): string {
    return PathUtility.SafetyEventEdit(id);
  }

  getViewRoute(id: string | number): string {
    const view: SafetyEventViewType = this.parameters['view'] || 'content';
    return PathUtility.SafetyEventView(id, view);
  }

  getGoBackRoute(id?: string | number): string {
    switch (this.mode) {
      case 'create':
      case 'view':
        return this.getGoHomeRoute();

      case 'edit':
        return this.getViewRoute(id!);

      default:
        return '';
    }
  }

  getGoHomeRoute(): string {
    return PathUtility.SafetyEvent();
  }
}
